/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import format from 'date-fns/format';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import {
  Panel,
  Button,
} from 'react-bootstrap';
import Nvl from 'loracoms/Nvl';
import Copy from 'loracoms/Copy';
import Editable from 'loracoms/Editable';
import ShowIf from 'loracoms/ShowIf';
import { normalizeAppEUI } from 'lorautils/IdUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import appActions from 'loraactions/app';
import deviceActions from 'loraactions/device';
import dpActions from 'loraactions/datapoint';
import flowActions from 'loraactions/flow';
import parserActions from 'loraactions/parser';
import DeleteAppModal from '../DeleteAppModal';
import DeleteErrorModal from '../DeleteErrorModal';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  app: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  updateApp: React.PropTypes.func.isRequired,
  updated: React.PropTypes.object.isRequired,
  countDevices: React.PropTypes.func.isRequired,
  countDataPoints: React.PropTypes.func.isRequired,
  countFlows: React.PropTypes.func.isRequired,
  countParsers: React.PropTypes.func.isRequired,
  devCntState: React.PropTypes.object.isRequired,
  dpCntState: React.PropTypes.object.isRequired,
  flowCntState: React.PropTypes.object.isRequired,
  parserCntState: React.PropTypes.object.isRequired,
  pushState: React.PropTypes.func.isRequired,
  getApp: React.PropTypes.func.isRequired,
};

class AppProps extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
      devCntState: props.devCntState,
      dpCntState: props.dpCntState,
      flowCntState: props.flowCntState,
      parserCntState: props.parserCntState,
      errors: new ErrorSet(),
    };
    this.handleSubmitName = this.handleSubmitName.bind(this);
    this.handleEditName = this.handleEditName.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.detailview.appprops');
  }

  componentWillMount() {
    const {
      appId,
      countDevices,
      countDataPoints,
      countFlows,
      countParsers,
    } = this.props;
    countDevices({ app: appId });
    countDataPoints({ app: appId });
    countFlows({ app: appId });
    countParsers({ app: appId });
  }

  componentWillReceiveProps(nextProps) {
    const {
      app,
      updated,
      devCntState,
      dpCntState,
      flowCntState,
      parserCntState,
    } = nextProps;
    this.setState({ app });

    if (updated !== this.props.updated) {
      if (updated.status === 'success') {
        const { appId, getApp } = nextProps;
        getApp(appId);
      }
    }

    if (devCntState !== this.props.devCntState) {
      this.setState({ devCntState });
    }
    if (dpCntState !== this.props.dpCntState) {
      this.setState({ dpCntState });
    }
    if (flowCntState !== this.props.flowCntState) {
      this.setState({ flowCntState });
    }
    if (parserCntState !== this.props.parserCntState) {
      this.setState({ parserCntState });
    }
  }

  handleSubmitName() {
    const { appId, updateApp } = this.props;
    const { editData: { name }, errors } = this.state;
    if (_.trim(name).length !== 0) {
      updateApp(appId, { name });
      this.setState({ editName: false });
    } else {
      this.setState({ errors: errors.add('FE_EMPTY', 'name') });
    }
  }

  handleEditName() {
    const { app: { data = {} } } = this.state;
    this.setState({
      editName: true,
      editData: { name: data.name },
    });
  }

  handleChangeName(data) {
    const { errors } = this.state;
    this.setState({ editData: data, errors: errors.remove('name') });
  }

  handleDelete() {
    const { devCntState, errors } = this.state;
    if (devCntState.status !== 'success') {
      return;
    }

    if (devCntState.data.count === 0) {
      this.setState({ showDelete: true });
    } else {
      this.setState({
        errors: errors.add('FE_DEVICESEXIST', 'delete'),
      });
    }
  }

  render() {
    const { appId, pushState } = this.props;
    const {
      app,
      editName = false,
      editData = {},
      devCntState: {
        status: devCountStatus,
        data: { count: devCount } = {},
      },
      dpCntState: {
        status: dpCountStatus,
        data: { count: dpCount } = {},
      },
      flowCntState: {
        status: flowCountStatus,
        data: { count: flowCount } = {},
      },
      parserCntState: {
        status: parserCountStatus,
        data: { count: parserCount } = {},
      },
      showDelete = false,
      errors,
    } = this.state;
    const { data = {} } = app;

    const devCntHeader = (
      <div className="text-center">
        {this.intlMsg.msg('devicecount')}
      </div>
    );
    const dpCntHeader = (
      <div className="text-center">
        {this.intlMsg.msg('dpcount')}
      </div>
    );
    const flowCntHeader = (
      <div className="text-center">
        {this.intlMsg.msg('flowcount')}
      </div>
    );
    const parserCntHeader = (
      <div className="text-center">
        {this.intlMsg.msg('parsercount')}
      </div>
    );

    return (
      <div>
        <div className={styles.container}>
          <Panel
            bsStyle="aisz-white"
            header={this.intlMsg.msg('title')}
            className={styles.basic}
          >
            <div className={styles.content}>
              <div className={styles.name}>
                <Editable
                  id="name"
                  edit={editName}
                  value={data.name}
                  data={editData}
                  onChange={this.handleChangeName}
                  formatter={x => <Nvl val={x} status={app.status} />}
                  error={this.intlMsg.errorMsg(errors.get('name'))}
                  errorPlacement={'top'}
                />
                <ShowIf if={editName}>
                  <ul className={styles.buttons}>
                    <li>
                      <Button
                        bsStyle="aisz-link-success"
                        onClick={this.handleSubmitName}
                      >
                        <span className="halflings halflings-ok" />
                      </Button>
                    </li>
                    <li>
                      <Button
                        bsStyle="aisz-link-warning"
                        onClick={() => this.setState({ editName: false, errors: errors.remove('name') })}
                      >
                        <span className="halflings halflings-remove" />
                      </Button>
                    </li>
                  </ul>
                </ShowIf>
                <ShowIf if={!editName}>
                  <Link
                    className={styles.edit}
                    onClick={this.handleEditName}
                  >
                    <span className="glyphicon glyphicon-pencil" />
                  </Link>
                </ShowIf>
              </div>
              <ul className={styles.props}>
                <li>
                  <span className={styles.label}>APPEUI</span>
                  <Nvl val={data.appeui} status={app.status} formatter={normalizeAppEUI} />
                  {' '}
                  <Copy id="appeui" text={data.appeui} />
                </li>
                <li>
                  <span className={styles.label}>
                    {this.intlMsg.msg('createtime')}
                  </span>
                  <Nvl
                    val={data.createdAt}
                    status={app.status}
                    formatter={x => format(x, 'YYYY-MM-DD HH:mm:ss')}
                  />
                </li>
              </ul>
              <div className={styles.delete}>
                <Button bsStyle="aisz-danger-b" onClick={this.handleDelete}>
                  {this.intlMsg.msg('delete')}
                  {' '}
                  <span className="halflings halflings-trash" />
                </Button>
              </div>
            </div>
          </Panel>
          <Panel
            bsStyle="aisz-info"
            header={devCntHeader}
            className={styles.count}
          >
            <Nvl val={devCount} status={devCountStatus} />
          </Panel>
          <ShowIf if="profile:cloud">
            <Panel
              bsStyle="aisz-info"
              header={parserCntHeader}
              className={styles.count}
            >
              <Link onClick={() => pushState(`/application/${appId}/parse`)}>
                <Nvl val={parserCount} status={parserCountStatus} />
              </Link>
            </Panel>
          </ShowIf>
          <ShowIf if="profile:cloud">
          <Panel
            bsStyle="aisz-info"
            header={dpCntHeader}
            className={styles.count}
          >
            <Link onClick={() => pushState(`/application/${appId}/dps`)}>
              <Nvl val={dpCount} status={dpCountStatus} />
            </Link>
          </Panel>
          </ShowIf>
          <ShowIf if="profile:cloud">
            <Panel
              bsStyle="aisz-info"
              header={flowCntHeader}
              className={styles.count}
            >
              <Link onClick={() => pushState(`/application/${appId}/flows`)}>
                <Nvl val={flowCount} status={flowCountStatus} />
              </Link>
            </Panel>
          </ShowIf>
        </div>
        <DeleteAppModal
          show={showDelete}
          appId={appId}
          onHide={() => this.setState({ showDelete: false })}
        />
        <DeleteErrorModal
          error={errors.getCode('delete')}
          onHide={() => this.setState({ errors: errors.remove('delete') })}
        />
      </div>

    );
  }
}

AppProps.propTypes = propTypes;

const mapStateToProps = state => ({
  app: state.app.getApp,
  updated: state.app.updateApp,
  devCntState: state.device.countDevices,
  dpCntState: state.datapoint.countDataPoints,
  flowCntState: state.flow.countFlows,
  parserCntState: state.parser.countParsers,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  updateApp: appActions.updateApp,
  getApp: appActions.getApp,
  countDevices: deviceActions.countDevices,
  countDataPoints: dpActions.countDataPoints,
  countFlows: flowActions.countFlows,
  countParsers: parserActions.countParsers,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AppProps));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/AppProps/index.jsx